export const fetchTenantUserQuery = () => {
    const query =`
    query{
        fetchTenantUser {
            id
            username
            fullName
        }
    }
`
    return query;
};

export const fetchTenantPropertiesQuery = () => {
    const query = `
    query{
        tenantProperty{
            propertyId
            property
            unit
            unitId
            tenantId
        }
    }`
    return query;
};

export const fetchTenantHistoryQuery = (tenantId) => {
    const query = `
    query{
        tenantHistory(tenantId: "${tenantId}"){
            tenancyDetails{
                rentBalance
                period
                currency
                depositPaid
                paymentDetails
            }
            propertyContacts{
                mobile
                email
                location
            }
        }
    }`
    return query;
}
